<template>
  <main>
    <template v-if="!isLoading">
      <section class="page-header">
        <div class="d-flex align-items-center">
          <span class="clickable mr-2" @click="$router.go(-1)" v-if="showGoBackButton">
            <i class="mdi mdi-chevron-left" style="font-size: 2rem"></i>
          </span>
          <div class="process-header">
            <h2 class="process-title mb-0">{{ pageTitle }}</h2>
            <h6 class="mt-0">{{ pageSubTitle }}</h6>
          </div>
        </div>
        <div class="d-flex">
          <lm-button-v2
            v-if="showGoBackButtonText"
            @click="$router.go(-1)"
          >
          Volver
          </lm-button-v2>
          <div
            v-for="(item, index) of stepsButtons"
            :key="index"
            :class="{'ml-3': item.condition}"
          >
            <lm-button-v2
              v-if="item.condition && (item.position === 'top' || item.position === 'both')"
              v-bind="item"
              :shape="item.icon ? 'circle': null"
              :loading="isProcessing"
              @click="item.click"
              :variant="item.variant"
            >
              {{ !item.icon ? item.label : null }}
            </lm-button-v2>
          </div>
          <template>
            <a-button
              v-if="isOnEditMode && form.lumbreStatus"
              :disabled="true"
              class="ml-3"
              :loading="isProcessing"
              :class="`status-button color-${statusToBeChanged ? statusToBeChanged.id : form.lumbreStatus.id}`"
            >
              <template >
                {{ form.lumbreStatusName }}
              </template>
            </a-button>
          </template>
        </div>
      </section>

      <section class="page-content">
        <div class="bg-light rounded-lg p-0 w-100">
          <section class="p-3 rounded-lg bg-white position-relative">
            <div class="d-flex justify-content-between">
              <div class="w-50">
                <LmTextInput
                  id="name"
                  :disabled="!showChangeableComponents"
                  v-model="form.name"
                  :v="validation('form.name')"
                  :label="$t('name')"
                  :placeholder="$t('blueprint_title_placeholder')"
                />
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex mb-2" style="gap: 2rem">
                  <div class="d-flex flex-column">
                    <small class="text-uppercase" style="font-size: 11px">Version</small>
                    <span class="h6 mt-0">{{ form.version }}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column align-items-end">
                <div class="d-flex justify-contet-center" style="gap: 1rem">
                  <div class="d-flex flex-column align-items-end">
                    <span class="text-uppercase">Cuenta:</span>
                    <span class="h6 mt-0">
                      {{ getFirstCuenta }}
                    </span>
                  </div>
                  <div class="d-flex flex-column align-items-end">
                    <a-badge
                      v-if="hasMoreThanOneNomenclaturas"
                      :count="form.nomenclaturas.length"
                    >
                      <span class="text-uppercase mr-4">Nomenclaturas</span>
                    </a-badge>
                    <span v-else class="text-uppercase">Nomenclatura:</span>
                    <span class="h6 mt-0 first-nomenclatura">
                      {{ getFirstNomenclatura }}
                      <a-tooltip v-if="hasMoreThanOneNomenclaturas" title="Primera Nomenclatura">
                        <a-icon type="info-circle" class="ml-2" />
                      </a-tooltip>
                    </span>
                  </div>
                </div>
                <lm-button-v2
                  v-if="showChangeNomenclaturaButton"
                  class="mt-2"
                  type="primary"
                  v-b-modal.nomenclaturas-datatable-modal
                >
                  {{nomenclaturaButtonLabel}}
                </lm-button-v2>
              </div>
            </div>
            <div class="w-100">
              <LmTextArea
                id="description"
                :disabled="!showChangeableComponents"
                class="col-12 px-0"
                v-model="form.description"
                :label="$t('description')"
                :placeholder="$t('blueprint_description_placeholder')"
              />
            </div>
            <b-card v-if="hasNomenclaturas" class="border mt-5" dy>
              <template>
                <b-row class="mb-2">
                  <h3 class="col-12">Mapa de nomenclaturas</h3>
                  <LmCheckbox
                    v-if="geoJsonHasContent"
                    class="col-12"
                    variant="switch"
                    labelSingle="Mostrar Parcelario"
                    v-model="enableGeoJson"
                  />
                  <LmLeaFletMap
                    :multiMarkerLatLng="nomenclaturasLatLng"
                    :multiTooltipLatLng="nomenclaturasLatLngTooltips"
                    :enableGeoJson="enableGeoJson"
                    :geojson="geojson"
                    :geojsonEnableTooltips="true"
                    geojsonLabelTooltip=""
                    geojsonFeaturePropertyTooltip="NOMENCLATU"
                    :zoom="13"
                    class="col-12"
                    height="400px"
                    />
                </b-row>
              </template>
            </b-card>

            <b-card class="border mt-5" no-body>
              <b-tabs card>
                <b-tab active title="Nomenclaturas">
                  <template v-if="hasNomenclaturas">
                    <LmDataTable
                      :slug="datatableForNomenclatura"
                      :queryString="nomenclaturasSelectedQs"
                      @onSelect="onNomenclaturaItemSelectedToBeRemoved"
                      hideButtons
                    />
                    <lm-button-v2
                    v-if="showChangeableComponents"
                    type="primary"
                    v-b-modal.nomenclaturas-datatable-modal>
                      {{nomenclaturaButtonLabel}}
                    </lm-button-v2>
                    <lm-button-v2
                    v-if="showChangeNomenclaturaButton && nomenclaturasSelecetedToRemove.length"
                    class="ml-2"
                    type="danger"
                    @click="onRemoveNomenclaturasConfirmation">
                      {{$t('delete')}}
                    </lm-button-v2>
                  </template>
                  <template v-else>
                    <h4 class="text-center h3 mb-4">
                      No hay nomenclaturas asociadas
                    </h4>
                    <lm-button-v2 v-if="showChangeNomenclaturaButton" type="primary" v-b-modal.nomenclaturas-datatable-modal>
                      {{nomenclaturaButtonLabel}}
                    </lm-button-v2>
                  </template>
                </b-tab>
              </b-tabs>
            </b-card>

            <b-card class="border mt-5" no-body>
              <b-tabs card>
                <b-tab active title="Plano">
                  <LmUploadFiles
                    v-if="showChangeableComponents"
                    ref="lmUploadFiles"
                    label="Subir plano"
                    @fileCreated="onAddBlueprintFile"
                    :duplicateCheck="true"
                    :hideRemoveAllToast="true"
                    :dropzoneOptions="{
                      acceptedFiles: acceptedFormats,
                      previewsContainer: false,
                      headers: {
                        'Cache-Control': null,
                        'X-Requested-With': null
                      },
                      withCredentials: true,
                      thumbnailWidth: 150,
                      maxFilesize: 100,
                      timeout: 120000,
                      addRemoveLinks: true,
                      maxFiles: 1,
                      clickable: true
                    }"
                  />
                  <div v-if="form.blueprintFiles.length">
                    <div class="col-12">
                      <div class="mb-2 text-right">
                        <lm-button-v2
                          v-if="showChangeableComponents"
                          @click="onRemoveBlueprintFile"
                          type="danger"
                          class="textend mb-2"
                        >
                          <a-icon type="delete"/>
                        </lm-button-v2>
                      </div>
                    </div>

                    <LmFileViewer class="cl-" ref="fileviewer" :files="form.blueprintFiles"/>
                  </div>
                  <template v-else>
                    <h4 class="text-center h3 mb-4">
                      No hay un plano asociado.
                    </h4>
                  </template>
                </b-tab>
                <b-tab title="Trámites asociados">
                  <div>
                    <a-table
                      class="col-12"
                      bordered
                      :columns="tableColumns"
                      :data-source="tableData"
                      :loading="isTableLoading"
                      :customRow="customRow"
                      :customHeaderRow="customHeaderRow"
                      :pagination="{ hideOnSinglePage: true }"
                    >
                      <div
                        slot="filterDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px"
                      >
                        <a-input
                          v-ant-ref="c => (searchInput = c)"
                          :placeholder="`Buscar ${column.title}`"
                          :value="selectedKeys[0]"
                          style="width: 188px; margin-bottom: 8px; display: block;"
                          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                          @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                        />
                        <a-button
                          type="primary"
                          icon="search"
                          size="small"
                          style="width: 90px; margin-right: 8px"
                          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                        >
                          Buscar
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                          Borrar
                        </a-button>
                      </div>
                      <a-icon
                        slot="filterIcon"
                        slot-scope="filtered"
                        type="search"
                        :style="{ color: filtered ? '#108ee9' : undefined }"
                      />
                      <span slot="name" slot-scope="text, record">
                        {{ text }}
                        <a-tooltip v-if="record.metadata.replacement_date"
                          :title="replacementFeedbackDateTooltip(record)">
                          <a-icon type="info-circle" class="ml-2" />
                        </a-tooltip>
                        <a-tooltip v-if="record.hasBeenDeleted"
                          :title="removedFeedbackDateTooltip(record)">
                          <a-icon type="info-circle" class="ml-2" />
                        </a-tooltip>
                      </span>
                      <span slot="action" slot-scope="text, record">
                        <div class="d-flex" style="column-gap: .5rem">
                          <a-tooltip title="Ver detalles">
                            <lm-button-v2 shape="circle" icon="edit" @click="onOpenItem(record)" />
                          </a-tooltip>
                        </div>
                      </span>
                    </a-table>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </section>

          <div class="d-flex m-4" style="gap: .5rem">
          </div>
          <div class="d-flex ml-2 mb-4" >
            <div
            v-for="(item, index) of stepsButtons"
            :key="index"
            :class="{'ml-3': item.condition}"
          >
            <lm-button-v2
              v-if="item.condition && (item.position === 'bottom' || item.position === 'both')"
              v-bind="item"
              :shape="item.icon ? 'circle': null"
              :loading="isProcessing"
              @click="item.click"
              :variant="item.variant"
            >
              {{ !item.icon ? item.label : null }}
            </lm-button-v2>
          </div>
          </div>
        </div>
        <LmToolbar
          ref="toolbar"
          class="bg-light"
          style="padding-top: 0"
          contentClass="border-0 shadow-none"
          :isOnEditMode="isOnEditMode"
          :items="toolbarItems"
          :config="toolbarConfig"
          @change="onToolbarModeChange"
          @onUnsavedChanges="onUnsavedChanges"
        />
      </section>
    </template>
    <LmLoading v-else />

    <!-- Modal de confirmación general -->
    <LmConfirmationModal
      ref="confirmation-modal"
    />
    <!-- Modal para nomenclaturas -->
    <b-modal
      id="nomenclaturas-datatable-modal"
      size="xl"
      scrollable
      hide-header
      @ok="onConfirmNomenclatura"
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <LmDataTable
        ref="datatable-app-nomenclatura"
        :slug="datatableForNomenclatura"
        :queryString="nomenclaturasToExcludeQs"
        hideButtons
      />
    </b-modal>
  </main>
</template>

<script>
import { defineComponent } from 'vue'

// Components
import LmDataTable from '@/components/lmDataTable/table'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmRadio from '@/components/form/elements/LmRadio'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmToolbar from '@/components/lmToolBar'
import LmFileViewer from '@/components/LmFileViewer'
import LmPeopleNewOrEdit from '@/views/LmPeopleNewOrEdit'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTextArea from '@/components/form/elements/LmTextArea'

// Utils
import lmToasts from '@/mixins/lmToasts.js'
import commonsApi from '@/api/commons'
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'
import moment from 'moment'
import 'moment/locale/es'

// Vuex
import { mapMutations, mapGetters } from 'vuex'

moment.locale('es')

export default defineComponent({
  mixins: [lmToasts],

  provide () {
    const context = {}
    for (const key in this.context) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.context[key]
      })
    }
    return { context }
  },

  components: {
    LmTreeSelect,
    LmButton,
    LmButtonV2,
    LmTextInput,
    LmRadio,
    LmUploadFiles,
    LmFormBuilder,
    LmDataTable,
    LmConfirmationModal,
    LmToolbar,
    LmFileViewer,
    LmPeopleNewOrEdit,
    LmGooglePlacesAutocomplete,
    LmLeaFletMap,
    LmCheckbox,
    LmTextArea
  },

  props: {
    showCrudButtons: {
      type: Boolean,
      default: true
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },

  validations () {
    const validations = {
      form: {}
    }
    validations.form.name = { required }
    return validations
  },

  data () {
    return {
      isLoading: false,
      isProcessing: false,
      isTableLoading: false,
      showReplacementDocumentModal: false,
      showFormbuilderForEdit: false,
      requestStartOptions: {
        areas: null,
        subareas: null,
        users: null
      },
      actionsAvailables: {
        canBeCreatedByMe: false,
        canBeEditedByMe: false,
        canBeDeletedByMe: false
      },
      toolbarMode: null,
      processChange: false,
      blueprintChange: false,
      statusChange: false,

      typeForm: {},
      formCopy: {},
      markerLatLng: [],
      form: {
        name: '',
        description: '',
        address: '',
        addressLatLong: [],
        nomenclaturas: [],
        blueprintFiles: [],
        deleted: false,
        blueprintRelationships: []
      },

      nomenclaturasSelecetedToRemove: [],
      enableGeoJson: false,
      geojson: {},
      originalName: '',
      originalDescription: '',
      processes: []
    }
  },

  computed: {
    ...mapGetters('processes', ['lastDocumentCreated', 'dataToPersist']),
    context () {
      return {
        toolbarCtx: 'processes'
      }
    },
    disableAutomations () {
      return process.env?.VUE_APP_ENABLE_AUTOMATIONS !== 'yes'
    },
    typeId () {
      return this.$route.params?.typeId || null
    },
    blueprintId () {
      return this.$route.params?.id || null
    },
    pageTitle () {
      return !this.isOnEditMode ? 'Crear nuevo plano' : this.form.name || 'Nombre del plano'
    },
    pageSubTitle () {
      return this.typeForm.typeAlias
    },
    formbuilderProcessUri () {
      return '/formbuilder/' + this.typeForm?.formbuilderId || ''
    },
    acceptedFormats () {
      return [
        { id: 1, name: 'PDF' }
      ]
    },
    nomenclaturasSelectedQs () {
      let qs

      if (this.form?.nomenclaturas?.length) {
        const nomenclaturaIds = this.form.nomenclaturas.map(el => el.id)
        if (nomenclaturaIds.length) {
          qs = '(cuenta: (' + nomenclaturaIds.join(' OR ') + '))'
        }
      }
      return qs
    },
    nomenclaturasToExcludeQs () {
      let qs = '*'

      if (this.form?.nomenclaturas?.length) {
        const nomenclaturaIds = this.form.nomenclaturas.map(el => el.id)
        if (nomenclaturaIds.length) {
          qs = 'NOT (cuenta: (' + nomenclaturaIds.join(' OR ') + '))'
        }
      }
      return qs
    },
    showSaveAsDraftButton () {
      if (
        this.showCrudButtons && ((this.actionsAvailables.canBeCreatedByMe || this.actionsAvailables.canBeEditedByMe) && (this.blueprintChange || !this.isOnEditMode))
      ) {
        return true
      }
      return false
    },
    showChangeableComponents () {
      if (
        this.showCrudButtons && (this.actionsAvailables.canBeCreatedByMe || this.actionsAvailables.canBeEditedByMe)
      ) {
        return true
      }
      return false
    },
    showUpdateVersion () {
      if (
        this.showCrudButtons && ((this.actionsAvailables.canBeCreatedByMe || this.actionsAvailables.canBeEditedByMe) && (this.blueprintChange || !this.isOnEditMode))
      ) {
        return true
      }
      return false
    },
    showGoBackButton () {
      return this.$route.params.showGoBackButton || true
    },
    showReactivateButton () {
      if (this.showCrudButtons && (this.isOnEditMode && this.actionsAvailables.canBeEditedByMe && this.form.deleted)) {
        return true
      }
      return false
    },
    showDeleteButton () {
      if (this.showCrudButtons && (this.isOnEditMode && this.actionsAvailables.canBeEditedByMe && !this.form.deleted)) {
        return true
      }
      return false
    },
    requestParams () {
      const payload = {
        ...this.form,
        typeId: this.typeId
      }
      if (this.isOnEditMode) {
        payload.id = this.blueprintId
      }
      delete payload.blueprintRelationships
      return payload
    },
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'tags'
        ]
        if (!this.hideComments) {
          items.unshift('comments')
        }
      } else {
        items = [
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        comments: {
          linkType: 'blueprints',
          disabled: this.disableComments
        },
        tags: {
          serviceName: 'blueprints'
        }
      }
    },
    requestersCategoriesOptions2 () {
      return [
        { text: 'Usuario', value: 'user' },
        { text: 'Área', value: 'area' },
        { text: 'Subárea', value: 'subarea' }
      ]
    },
    stepsButtons () {
      return [
        {
          label: this.$t('cancel'),
          type: 'secondary',
          position: 'bottom',
          condition: true,
          click: () => this.onCancel()
        },
        {
          label: this.isOnEditMode ? this.$t('update_version') : this.$t('save'),
          // icon: 'save',
          type: 'primary',
          variant: 'primary',
          position: 'both', // posible values top, bottom or both
          condition: this.showUpdateVersion,
          click: () => this.onSave()
        },
        {
          label: this.$t('reactivate'),
          type: 'warning',
          confirmation: true,
          confirmationTitle: this.$t('reactivate_blueprint'),
          confirmationMessage: this.$t('are_you_sure_you_want_to_reactivate_this_blueprint', this.form),
          position: 'bottom',
          condition: this.showReactivateButton,
          click: () => this.onReactivate()
        },
        {
          label: this.$t('delete'),
          type: 'danger',
          confirmation: true,
          confirmationTitle: this.$t('delete_blueprint'),
          confirmationMessage: this.$t('are_you_sure_you_want_to_delete_this_blueprint', this.form),
          position: 'bottom',
          condition: this.showDeleteButton,
          click: () => this.onDelete()
        }
      ]
    },

    showGoBackButtonText () {
      return 'viewer' in this.$route.query
    },

    datatableForNomenclatura () {
      return 'nomenclaturas-internals'
    },

    getFirstNomenclatura () {
      if (this.hasNomenclaturas) {
        return this.form.nomenclaturas[0].code
      } else {
        return 'Sin Nomenclatura'
      }
    },
    getFirstCuenta () {
      if (this.hasNomenclaturas) {
        return this.form.nomenclaturas[0].id
      } else {
        return 'Sin Cuenta'
      }
    },
    hasNomenclaturas () {
      return this.form?.nomenclaturas?.length > 0
    },

    hasMoreThanOneNomenclaturas () {
      return this.form?.nomenclaturas?.length > 1
    },

    showChangeNomenclaturaButton () {
      return (this.showCrudButtons && ((!this.isOnEditMode && this.actionsAvailables.canBeCreatedByMe) || (this.isOnEditMode && this.actionsAvailables.canBeEditedByMe)))
    },

    nomenclaturaButtonLabel () {
      return this.hasNomenclaturas ? 'Agregar' : 'Asociar'
    },

    nomenclaturasLatLng () {
      return this.form.nomenclaturas.map(n => n.nomenclaturaLatLong)
    },

    nomenclaturasLatLngTooltips () {
      return this.form.nomenclaturas.map(n => n.code)
    },

    geoJsonHasContent () {
      return Object.keys(this.geojson).length > 0
    },
    tableColumns () {
      return [
        {
          title: 'Número',
          dataIndex: 'processNumber',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const processNumber = record.processNumber || ''
            return processNumber
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              this.searchInput.focus()
            }
          }
        },
        {
          title: 'Nombre',
          dataIndex: 'processName'
        },
        {
          title: 'Alias',
          dataIndex: 'processTypeAlias'
        },
        {
          title: 'Estado',
          dataIndex: 'lumbreStatusName'
        },
        {
          title: 'Fecha',
          dataIndex: 'createdAt'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    tableData () {
      return this.processes.map((el, index) => {
        return {
          key: index,
          processId: el._id,
          processName: el.processName,
          processTypeAlias: el.processTypeAlias,
          processNumber: el.processNumber,
          lumbreStatusName: el.lumbreStatusName,
          processTypeId: el.processTypeId,
          editSlug: el.editSlug,
          createdAt: moment(el.createdAt).format('DD [de] MMM, YYYY - HH:mm')
        }
      })
    }
  },

  methods: {
    ...mapMutations('processes', ['setDataToPersist', 'setProcessPath', 'clearProcessesStore']),
    onCancel () {
      this.$router.go(-1)
    },
    customRow (record, index) {
      const props = {}
      if (record.hasBeenDeleted) {
        props.class = 'a-table-row-disabled'
      } else if (record.hasBeenCorrected) {
        props.class = 'a-table-row'
      }
      props.class += ' a-table-row'
      return props
    },

    customHeaderRow (column, index) {
      return {
        class: 'a-table-header-row'
      }
    },

    onToolbarModeChange (event) {
      this.toolbarMode = event
    },

    validation (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },

    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
      //   this.lmToastWarningMessage(
      //     'No podrás crear el plano hasta que completes los campos del formulario correctamente',
      //     'Formulario con errores'
      //   )
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },

    onOpenToolbarProcessPasses () {
      this.$refs.toolbar.updateToolbarMode('processPasses')
    },

    processPath (event) {
      return {
        name: 'process-editar',
        params: {
          typeId: event.typeId,
          id: event.id,
          showGoBackButton: true
        }
      }
    },

    async onUnsavedChanges () {
      this.lmModalWarningMessage({
        resultTitle: this.$t('changes_unsaved'),
        resultSubtitle: this.$t('changes_unsaved_subtitle'),
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('save'),
            btnCallback: async () => {
              await this.onSave()
              this.$refs.toolbar.updateToolbarMode('processPasses')
            }
          }
        ]
      })
    },

    async onSave () {
      try {
        this.isProcessing = true
        if (this.form.nomenclaturas.length === 0) {
          this.lmModalInformationMessage({
            modalClosable: true,
            modalKeyboard: true,
            resultSubtitle: '',
            buttons: [
              {
                btnText: this.$t('continue'),
                btnGhost: true,
                btnCallback: () => {
                  this.isProcessing = false
                }
              }
            ],
            message: this.$t('blueprints_must_include_at_least_one_nomenclatura')
          })
          return
        }
        if (this.form.blueprintFiles.length === 0) {
          this.lmModalInformationMessage({
            modalClosable: true,
            modalKeyboard: true,
            resultSubtitle: '',
            buttons: [
              {
                btnText: this.$t('continue'),
                btnGhost: true,
                btnCallback: () => {
                  this.isProcessing = false
                }
              }
            ],
            message: this.$t('blueprints_must_include_at_least_one_file')
          })
          return
        }
        if (this.isOnEditMode) {
          const response = await commonsApi.axiosPutWrapper(`/blueprints/edit/${this.blueprintId}`, this.requestParams)

          if (this.statusChange) {
            await this.getBlueprint()
          }

          this.lmModalSuccessWithButtons({
            modalClosable: true,
            modalKeyboard: true,
            buttons: [
              {
                btnText: this.$t('continue'),
                btnCallback: async () => {
                  this.$router.replace(`/planos/${response.data.typeId}/editar/${response?.data?._id}`)
                }
              }
            ],
            message: this.$t('blueprint_update_succeded', { name: response?.data?.name })
          })
        } else {
          const response = await commonsApi.axiosPostWrapper('/blueprints/new', this.requestParams)

          this.lmModalSuccessWithButtons({
            modalClosable: false,
            modalKeyboard: false,
            buttons: [
              {
                btnText: this.$t('continue'),
                btnCallback: async () => {
                  this.$router.replace(`/planos/${response.data.typeId}/editar/${response?.data?._id}`)
                }
              }
            ],
            message: this.$t('blueprint_create_succeded', { name: response?.data?.name })
          })
        }
        this.blueprintChange = false
        this.processChange = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    fileIsValidForViewer (filename) {
      const extensionesValidas = ['pdf', 'png', 'jpeg', 'jpg', 'gif']
      return extensionesValidas.some(palabra => filename.toLowerCase().endsWith(palabra))
    },

    async onConfirmNomenclatura () {
      try {
        this.isTableLoading = true
        const selected = this.$refs['datatable-app-nomenclatura'].dataValue
        if (selected) {
          const nomenclaturaIds = selected.map(el => el['nomenclaturas-cuenta'].toString())

          if (!nomenclaturaIds.length) return

          const response = await commonsApi.axiosPostWrapper('/nomenclaturas/es-search', {
            ids: nomenclaturaIds,
            fields: ['cuenta', 'datos_catastrales', 'nomenclaturaLatLong']
          })

          const items = response.data.items.map(el => {
            return {
              id: el.cuenta,
              code: el.datos_catastrales,
              nomenclaturaLatLong: el.nomenclaturaLatLong
            }
          })
          this.form.nomenclaturas = items
          this.blueprintChange = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isTableLoading = false
      }
    },

    updateProcessForm (event) {
      for (const key in event) {
        if (this.form.hasOwnProperty(key)) {
          if (this.form[key] !== event[key]) {
            this.processChange = true
            break
          } else {
            this.processChange = false
          }
        }
      }
      this.form = Object.assign({}, this.form, event)
    },

    async getBlueprintType () {
      const response = await commonsApi.axiosGetWrapper('/blueprinttypes/' + this.typeId)
      this.typeForm = response.data
      // return this.getRequestStartOptions()
    },

    async getBlueprint () {
      if (!this.isOnEditMode) return
      const response = await commonsApi.axiosGetWrapper(`/blueprints/${this.blueprintId}`)
      this.form = response.data
      this.originalName = this.form.name
      this.originalDescription = this.form.description
      this.$watch('form.name', this.nameWatcher)
      this.$watch('form.description', this.descriptionWatcher)
      this.markerLatLng = this.form?.addressLatLong || []
    },

    async getActionsAvailables () {
      let targetEndpoint
      if (!this.isOnEditMode) {
        targetEndpoint = '/blueprints/actionsavailableoncreate/' + this.typeId
      } else {
        targetEndpoint = '/blueprints/actionsavailable/' + this.blueprintId
      }
      const response = await commonsApi.axiosGetWrapper(targetEndpoint)
      this.actionsAvailables = response.data
    },

    validateTypeIsPublished () {
      if (!this.isOnEditMode && !this.typeForm.publish) {
        this.lmModalDangerMessage({
          btnText: this.$t('go_back'),
          btnLink: 'goback',
          modalClosable: false,
          modalKeyboard: false,
          resultSubtitle: this.$t('talk_to_admin'),
          message: this.$t('blueprint_type_not_published')
        })
      }
    },

    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/blueprints/reactivate/${this.blueprintId}`)
        this.lmToastSuccessMessage(`Se reactivo correctamente el plano ${this.form.name}.`, `Operación realizada con éxito.`)
        this.$router.go(-1)
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/blueprints/delete/${this.blueprintId}`)
        this.lmToastSuccessMessage(`Se eliminó correctamente el plano ${this.form.name}.`, `Operación realizada con éxito.`)
        this.$router.go(-1)
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    onNomenclaturaItemSelectedToBeRemoved (event) {
      this.nomenclaturasSelecetedToRemove = event
    },

    onRemoveNomenclaturasConfirmation () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.onRemoveNomenclaturas()
            }
          }
        ],
        message: this.$t('blueprints_remove_nomenclatura_confirmation')
      })
    },

    async onRemoveNomenclaturas () {
      try {
        if (this.nomenclaturasSelecetedToRemove.length === 0) {
          return
        }
        this.isProcessing = true
        this.form.nomenclaturas = []
        this.blueprintChange = true
        this.nomenclaturasSelecetedToRemove = []
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    onAddBlueprintFile (event) {
      this.blueprintChange = true
      this.form.blueprintFiles = []
      this.form.blueprintFiles = [{
        id: event.id || event.uuid,
        ...event,
        src: event.path,
        path: process.env.VUE_APP_API_URL_STATIC_ASSETS + event.path
      }]
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.fileviewer.lazyLoadUpdate(this.form.blueprintFiles[0])
    },

    onRemoveBlueprintFile () {
      this.form.blueprintFiles = []
    },

    async nameWatcher (val) {
      if (this.originalName !== val) {
        await this.validateForm(this.$v)
        this.blueprintChange = true
      } else {
        this.blueprintChange = false
      }
    },

    async descriptionWatcher (val) {
      if (this.originalDescription !== val) {
        await this.validateForm(this.$v)
        this.blueprintChange = true
      } else {
        this.blueprintChange = false
      }
    },

    async getRelatedProcesses () {
      if (!this.isOnEditMode) return
      if (this.$route.params.id) {
        try {
          const processesResponse = await commonsApi.axiosGetWrapper(`/blueprints/relatedprocesses/${this.$route.params.id}`)
          this.processes = processesResponse.data
        } catch (error) {
          console.log(error)
        } finally {
          this.isTableLoading = false
        }
      }
    },

    onOpenItem (item) {
      this.$router.push(item.editSlug)
    }
  },

  watch: {
  },

  async mounted () {
    try {
      this.isLoading = true
      const promises = [
        this.getBlueprintType(),
        this.getBlueprint(),
        this.getActionsAvailables(),
        this.getRelatedProcesses()
      ]

      await Promise.all(promises)
      this.validateTypeIsPublished()

      if (
        this.lastDocumentCreated &&
        !this.form.documents.some(el => el.id === this.lastDocumentCreated.id)
      ) {
        const response = await commonsApi.axiosPostWrapper('/documents/es-search', {
          ids: [this.lastDocumentCreated.id],
          fields: ['id', 'documentTypeId', 'documentName', 'documentNumber', 'documentTypeAlias']
        })
        const documentMetadata = response.data.items.at(0)
        const document = {
          document: documentMetadata,
          order: 'N/A',
          canBeDeleted: true,
          canBeCorrected: false,
          id: documentMetadata.id,
          metadata: {}
        }
        this.form.documents.push(document)
        this.blueprintChange = true
      }

      this.formCopy = _.cloneDeep(this.form)
      this.$watch('form.name', (val) => {
        this.processChange = Boolean(val)
      })
      this.$watch('form.address', (val) => {
        this.processChange = Boolean(val)
      })
      // const response = await commonsApi.axiosGetWrapper('/parcelarias/geojson')
      // this.geojson = response.data
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },

  beforeRouteLeave (to, from, next) {
    if (
      (this.showSaveAsDraftButton || this.showUpdateVersion) && this.blueprintChange
    ) {
      this.lmModalWarningMessage({
        resultTitle: this.$t('changes_unsaved'),
        resultSubtitle: this.$t('changes_unsaved_subtitle'),
        buttons: [
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.blueprintChange = false
              this.$router.push(to.path)
            }
          },
          {
            btnText: this.$t('save'),
            btnCallback: async () => {
              await this.onSave()
              this.$router.push(to.path)
            }
          }
        ]
      })
      return false
    }
    next()
  }

})
</script>

<style scoped>
.first-nomenclatura {
  text-align: end;
}

.page-header {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 1rem 2rem;
  z-index: 4;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 95px;
}

#lm-leaflet-map {
  z-index: 0;
}

@media all and (max-width: 768px) {
  .page-header {
    padding: .4rem .8rem;
    height: auto;
  }
  .page-header h2 {
    font-size: 1.2rem;
    margin-bottom: 5px !important;
  }
}

.process-header > .process-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.page-content {
  width: calc(100% + 1rem);
  min-height: calc(100vh - 70px - 60px - 95px);
  margin-left: auto;
  /* display: flex; */

  display: grid;
  grid-template-columns: calc(100% - 100px) 100px;
}

.status-squad-icon {
  width: 10px;
  height: 10px;
  display: inline-block;
  vertical-align: inherit;
  margin: 0 6px 0 0;
  background-color: orange;
}
.status-button {
  background-color: orange;
  color: white;
}
.status-button:hover {
  background-color: orange;
  color: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: scale(1.05);
  transition: ease-in-out .25s transform;
  border-color: rgba(149, 157, 165, 0.2);
}
.status-button:focus {
  border-color: rgba(149, 157, 165, 0.2);
}
.status-squad-icon.color-5, .status-button.color-5, .status-button:hover.color-5 {
  background-color: yellow;
  color: black;
}
.status-squad-icon.color-6, .status-button.color-6, .status-button:hover.color-6 {
  background-color: cadetblue;
}
.status-squad-icon.color-1, .status-button.color-1, .status-button:hover.color-1 {
  background-color: green;
}
.status-squad-icon.color-8, .status-button.color-8, .status-button:hover.color-8 {
  background-color: violet;
}
.status-squad-icon.color-9, .status-button.color-9, .status-button:hover.color-9 {
  background-color: rebeccapurple;
}
.status-squad-icon.color-2, .status-button.color-2, .status-button:hover.color-2 {
  background-color: red;
}
.status-squad-icon.color-11, .status-button.color-11, .status-button:hover.color-11 {
  background-color: plum;
  color: black;
}
.status-squad-icon.color-12, .status-button.color-12, .status-button:hover.color-12 {
  background-color: teal;
}
.status-squad-icon.color-13, .status-button.color-13, .status-button:hover.color-13 {
  background-color: tomato;
}
.status-squad-icon.color-14, .status-button.color-14, .status-button:hover.color-14 {
  background-color: turquoise;
}
</style>
